

import { createAction, props } from '@ngrx/store';

import { type } from '@app/util/util';
import { AirResultOptionResponse } from '@packages/packages-result/entities/air-results';
import { PackageSeachResponse } from '@packages/packages-result/entities/packages-search';
import { FlightResultDesktop } from '@app/entities/flight-results';

export const initPackageLocalStorageAction = createAction(
  type('[LocalStorage/Data] Set LocalStorage Package Hotel Detail'),
  props<{
    airSelected: AirResultOptionResponse | FlightResultDesktop,
    data: PackageSeachResponse
  }>());
